export const IMPERSONATOR_TYPES = {
  PM: 'pm',
  CONTACT: 'contact',
  OWNER: 'owner',
};
